// src/task/TaskColumn.js
import React from 'react';
import { Droppable, Draggable } from '@hello-pangea/dnd';
import { useNavigate } from 'react-router-dom';
import TaskCard from './TaskCard';

const TaskColumn = ({ 
  title, 
  droppableId, 
  count, 
  tasks, 
  couleur, 
  isMobile, 
  isDragDisabled = false,
  userRole = 'fonctionelle' 
}) => {
  const navigate = useNavigate();

  const handleTaskClick = (task) => {
    const path = userRole === 'admin-client' 
      ? `/admin-client/task/${task.id}` 
      : userRole === 'fonctionelle'
      ? `/fonctionelle/task/${task.id}`
      : `/ChefProjet/task/${task.id}`;
    
    navigate(path, { state: { task } });
  };

  const columnStyle = couleur
    ? { backgroundColor: `${couleur}20`, borderColor: couleur }
    : {};
  const headerStyle = couleur
    ? { backgroundColor: `${couleur}40` }
    : {};

  return (
    <div
      className={`rounded-md border shadow-sm ${isMobile ? 'w-full' : 'flex-1 min-w-[240px] max-w-[280px]'}`}
      style={columnStyle}
    >
      {/* En-tête */}
      <div
        className="flex items-center justify-between p-2 rounded-t-md border-b"
        style={headerStyle}
      >
        <div className="flex items-center gap-2">
          <h2 className="text-sm font-semibold text-gray-800">{title}</h2>
          <span className="text-xs px-2 py-1 rounded-full bg-white font-medium">
            {count} {count > 1 ? 'tickets' : 'ticket'}
          </span>
        </div>
      </div>

      {/* Zone des tickets */}
      <Droppable droppableId={droppableId} isDropDisabled={isDragDisabled}>
        {(provided) => (
          <div
            className={`p-2 space-y-2 bg-white/50 rounded-b-lg transition-all duration-200 ${isMobile ? 'max-h-[300px]' : 'max-h-[650px]'} overflow-y-auto`}
            style={{ minHeight: "80px" }}
            ref={provided.innerRef}
            {...provided.droppableProps}
          >
            {tasks.length === 0 ? (
              <div className="text-center py-4 text-sm text-gray-500">
                Aucun ticket dans cette colonne
              </div>
            ) : (
              tasks.map((task, index) => (
                <Draggable
                  key={task.id}
                  draggableId={task.id.toString()}
                  index={index}
                  isDragDisabled={isDragDisabled}
                >
                  {(provided) => (
                    <div
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                      onClick={() => handleTaskClick(task)}
                      className="cursor-pointer hover:scale-[1.01] transition-transform duration-150"
                    >
                      <TaskCard 
                        id={task.id}
                        title={task.nom}
                        content={task.content}
                        priorite={task.priorite}
                        status={task.status}
                        type={task.type}
                        deadlineClient={task.deadline_client}
                        createur={task.createur}
                        developpeurs={task.developpeurs}
                        isMobile={isMobile}
                      />
                    </div>
                  )}
                </Draggable>
              ))
            )}
            {provided.placeholder}
          </div>
        )}
      </Droppable>

      {/* Pied de colonne si plus de 3 tickets */}
      {tasks.length > 3 && (
        <div className="px-2 py-1 text-[10px] text-center text-gray-600 border-t rounded-b-md">
          {tasks.length} tickets au total
        </div>
      )}
    </div>
  );
};

export default TaskColumn;